import Grid from '@mui/material/Grid';

import { ReportItemErrorBoundary } from './reportItemErrorBounday';
import { ReportGridItem } from '../../types/report';
import { getReportCardHeight, getReportCardWidths } from '../../utils/reportCardDimensions';
import { ReportCard } from '../reportCard';

export const ReportContent = ({
  clearFilters,
  items,
}: {
  clearFilters?: () => void;
  items: ReportGridItem[];
}) => {
  return (
    <>
      <Grid container={true} spacing={2}>
        {items.map((gridItem, idx) => {
          const widths = gridItem.display?.widths
            ? {
                ...(gridItem.display.widths.maxWidth && {
                  maxWidth:
                    typeof gridItem.display.widths.maxWidth === 'string' &&
                    gridItem.display.widths.maxWidth.includes('%')
                      ? `calc(${gridItem.display.widths.maxWidth} - 8px)` // spacing on grid - so 50% and 50% fit in 1 row
                      : gridItem.display.widths.maxWidth,
                }),
                ...(gridItem.display.widths.minWidth && {
                  minWidth: gridItem.display.widths.minWidth.includes('%')
                    ? `calc(${gridItem.display.widths.minWidth} - 8px)` // spacing on grid - so 50% and 50% fit in 1 row
                    : gridItem.display.widths.minWidth,
                }),
                // If maxWidth is 100%, set flexBasis to 100% to make it actually grow to full width
                ...(gridItem.display.widths.maxWidth === '100%' && {
                  flexBasis: '100%',
                }),
                width: '100%',
              }
            : getReportCardWidths(gridItem);

          return (
            <Grid key={`item-${idx}`} {...widths}>
              <ReportItemErrorBoundary key={JSON.stringify(gridItem)} title={gridItem.title}>
                <ReportCard
                  cellFormatter={gridItem.display?.cellFormatter}
                  clearFilters={clearFilters}
                  columnFormatter={gridItem.display?.columnFormatter}
                  description={gridItem.description}
                  query={{
                    baseQuery: gridItem.baseQuery,
                    params: {
                      ...gridItem.params,
                    },
                  }}
                  sx={{
                    height: gridItem.display?.height ?? getReportCardHeight(gridItem),
                  }}
                  title={gridItem.title}
                  variant={gridItem.display.visualization}
                />
              </ReportItemErrorBoundary>
            </Grid>
          );
        })}
      </Grid>
    </>
  );
};
